<div class="learning-section-container-single-edit-dialog">
    <div
        class="close-modal"
        (click)="onCancel()"
        (keydown.escape)="onCancel()"
        tabindex="0"
    >
        <mat-icon>close</mat-icon>
    </div>
    <h1 mat-dialog-title>Container editieren</h1>
    <mat-divider></mat-divider>
    <mat-dialog-content class="grid">
        <form [formGroup]="formGroup">
            <div class="form-fields">
                <mat-form-field class="form-field">
                    <mat-label>Titel</mat-label>
                    <input
                        matInput
                        type="text"
                        placeholder=""
                        formControlName="title"
                        required
                    />
                    <mat-error>{{ checkForErrors(formGroup.controls["title"]) }} </mat-error>
                </mat-form-field>

                @if (this.data.content && this.data.content.name) {
                <mat-card
                    appearance="outlined"
                    class="selected-content"
                >
                    <mat-card-content>
                        <span>Derzeitige Verknüpfung:</span>
                        @if (this.data.content.constructor) {
                        <div>
                            {{ getLearningSectionContainerContentType(this.data.content.constructor.name)?.label }}:
                            {{ this.data.content.name }}
                        </div>
                        }
                    </mat-card-content>
                </mat-card>
                }

                <mat-slide-toggle
                    formControlName="fullWidth"
                    labelPosition="before"
                    class="slide-toggler"
                >Volle Breite </mat-slide-toggle>
            </div>
        </form>

        <div class="my-3"></div>

        <mat-card appearance="outlined">
            <mat-tab-group
                (selectedTabChange)="onTabChange($event)"
                [(selectedIndex)]="activeTabIndex"
                class="container-content-tab-group"
            >
                <mat-tab
                    label="editor"
                    [disabled]="isTabLocked('editor')"
                >
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">ink_pen</mat-icon>
                        <span>Pixl-Inhalt</span>
                    </ng-template>

                    <div class="tab-content">
                        <mat-form-field>
                            <mat-label>PIXL-Content Suche</mat-label>
                            <input
                                matInput
                                type="text"
                                [(ngModel)]="searchTerm"
                                name="explanationContentSearch"
                                (blur)="onSearchChange($event)"
                            />
                            @if (searchTerm) {
                            <button
                                matSuffix
                                mat-icon-button
                                aria-label="Clear"
                                (click)="searchTerm = ''"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                            }
                        </mat-form-field>

                        @if (explanationContents$ | async; as sj) {
                        <mat-form-field style="width: 100%">
                            <mat-label>PIXL-Inhalte</mat-label>
                            <mat-select
                                #explanationContentSelect
                                [(ngModel)]="selectedContent"
                                placeholder="explanationContentSelect"
                                (closed)="onEditorSelectClosed()"
                                (openedChange)="onSelectOpened($event, explanationContentSelect)"
                            >
                                @for (explanationContent of explanationContents$ | async; track explanationContent.id) {
                                <mat-option [value]="explanationContent">{{ explanationContent.name }} </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }

                        <div class="py-2"></div>

                        <mat-form-field
                            class="form-field"
                            style="width: 50%"
                        >
                            <mat-label>Name</mat-label>
                            <input
                                matInput
                                [formControl]="explanationContentName"
                                type="text"
                                placeholder=""
                                required
                            />
                            @if (explanationContentName.hasError("required")) {
                            <mat-error>Dies ist ein Pflichtfeld.</mat-error>
                            }
                            @if (explanationContentName.hasError("unique")) {
                            <mat-error>Der Name wird bereits verwendet.</mat-error>
                            }
                        </mat-form-field>

                        @if (!this.checkNewEditorContent()) {
                        <span class="px-2"></span>

                        <button
                            mat-raised-button
                            color="primary"
                            (click)="onCopy()"
                        >Kopie erstellen</button>
                        }

                        <div class="py-2"></div>

                        <pixl-editor
                            [htmlString]="explanationContentHtml"
                            [editorHeight]="'auto'"
                            [bearerToken]="authToken!"
                            [assetUrl]="assetsUrl"
                            [mediaUrl]="mediaUrl"
                            [(editedHtmlString)]="explanationContentHtml"
                        >
                        </pixl-editor>
                    </div>
                </mat-tab>
                <mat-tab
                    label="sequence"
                    [disabled]="isTabLocked('sequence')"
                >
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">link</mat-icon>
                        <span> Lernsequenz</span>
                    </ng-template>

                    <div class="tab-content">
                        <mat-form-field>
                            <mat-label>Lernsequenz-Suche</mat-label>
                            <input
                                matInput
                                type="text"
                                [(ngModel)]="searchTerm"
                                name="sequenceSearch"
                                (blur)="onSearchChange($event)"
                            />
                            @if (searchTerm) {
                            <button
                                matSuffix
                                mat-icon-button
                                aria-label="Clear"
                                (click)="searchTerm = ''"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                            }
                        </mat-form-field>

                        @if (sequences$ | async; as sj) {
                        <mat-form-field style="width: 100%">
                            <mat-label>Lernsequenzen</mat-label>
                            <mat-select
                                #sequenceSelect
                                [(ngModel)]="selectedContent"
                                placeholder="sequenceSelect"
                                (openedChange)="onSelectOpened($event, sequenceSelect)"
                            >
                                @for (sequence of sequences$ | async; track sequence.id) {
                                <mat-option [value]="sequence">{{ sequence.name }} </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }
                    </div>
                </mat-tab>
                @if (showExplanationTab) {
                <mat-tab
                    label="explanation"
                    [disabled]="isTabLocked('explanation')"
                >
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">link</mat-icon>
                        <span>Erkläreinheit</span>
                    </ng-template>

                    <div class="tab-content">
                        <mat-form-field>
                            <mat-label>Erkläreinheit-Suche</mat-label>
                            <input
                                matInput
                                type="text"
                                [(ngModel)]="searchTerm"
                                name="explanationSearch"
                                (blur)="onSearchChange($event)"
                            />
                            @if (searchTerm) {
                            <button
                                matSuffix
                                mat-icon-button
                                aria-label="Clear"
                                (click)="searchTerm = ''"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                            }
                        </mat-form-field>

                        @if (explanations$ | async; as sj) {
                        <mat-form-field style="width: 100%">
                            <mat-label>Erkläreinheiten</mat-label>
                            <mat-select
                                #explanationSelect
                                [(ngModel)]="selectedContent"
                                placeholder="explanationSelect"
                                (openedChange)="onSelectOpened($event, explanationSelect)"
                            >
                                @for (explanation of explanations$ | async; track explanation.id) {
                                <mat-option [value]="explanation">{{ explanation.name }} </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }
                    </div>
                </mat-tab>
                }
                <mat-tab
                    label="test"
                    [disabled]="isTabLocked('test')"
                >
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">link</mat-icon>
                        <span> Test</span>
                    </ng-template>

                    <div class="tab-content">
                        <mat-form-field>
                            <mat-label>Test-Suche</mat-label>
                            <input
                                matInput
                                type="text"
                                [(ngModel)]="searchTerm"
                                name="testSearch"
                                (blur)="onSearchChange($event)"
                            />
                            @if (searchTerm) {
                            <button
                                matSuffix
                                mat-icon-button
                                aria-label="Clear"
                                (click)="searchTerm = ''"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                            }
                        </mat-form-field>

                        @if (tests$ | async; as sj) {
                        <mat-form-field style="width: 100%">
                            <mat-label>Tests</mat-label>
                            <mat-select
                                #testSelect
                                [(ngModel)]="selectedContent"
                                placeholder="testSelect"
                                (openedChange)="onSelectOpened($event, testSelect)"
                            >
                                @for (test of tests$ | async; track test.id) {
                                <mat-option [value]="test">{{ test.name }} </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card>

        <div class="my-4"></div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <div
        mat-dialog-actions
        align="end"
    >
        <button
            mat-raised-button
            color="primary"
            (click)="onSave()"
        >Speichern</button>
        <button
            mat-raised-button
            color="primary"
            (click)="onClose()"
        >Schließen</button>
    </div>
</div>